export default {
  state: {
		token: '',
	},

	mutations: {
		setGuestToken(state, payload) {
			state.token = payload
		},
	},

	getters: {
		guestToken(state) {
			return state.token
		},
	},

	actions: {
		async tryGuestLoginFromTg({dispatch, commit}, { chatId, hash}) {
      var r = await dispatch(
        'apiRequest', 
        {
          method: 'POST',
          endpoint: '/auth/login/guest',
          body: {
            chat_id: chatId,
						hash: hash,
          }
        }
      )

      commit('setGuestToken', (await r.json()).data.token)
		}
	}
}